// extracted by mini-css-extract-plugin
export var stepActive = "_2k-3";
export var stepCompleted = "_2k-4";
export var stepConnectorLine = "_2k-b";
export var stepIndicatorCircle = "_2k-6";
export var stepIndicatorCircleCompleted = "_2k-7";
export var stepIndicatorCircleDefault = "_2k-8";
export var stepIndicatorTextCompleted = "_2k-9";
export var stepIndicatorTextDefault = "_2k-a";
export var stepPending = "_2k-5";
export var wizardContainer = "_2k-1";
export var wizardContent = "_2k-2";
export var wizardModal = "_2k-0";